export enum Mode {
  SINGLE_BUILDING,
  MULTI_BUILDING,
  SINGLE_FLOOR,
  MULTI_FLOOR,
  SINGLE_BUILDING_FLOOR,
  MULTI_REGION_CITY_BUILDING,
  MULTI_REGION_CITY,
}

export const ModeMeta = {
  [Mode.SINGLE_BUILDING]: {
    building: true,
    multi: false,
    floor: false,
  },
  [Mode.MULTI_BUILDING]: {
    building: true,
    multi: true,
    floor: false,
  },
  [Mode.SINGLE_FLOOR]: {
    building: false,
    multi: false,
    floor: true,
  },
  [Mode.MULTI_FLOOR]: {
    building: false,
    multi: true,
    floor: true,
  },
  [Mode.SINGLE_BUILDING_FLOOR]: {
    building: true,
    multi: false,
    floor: true,
  },
  [Mode.MULTI_REGION_CITY_BUILDING]: {
    building: true,
    multi: false,
    floor: true,
  },
  [Mode.MULTI_REGION_CITY]: {
    building: false,
    multi: true,
    floor: false,
  },
}

export enum LocationType {
  REGION,
  CITY,
  BUILDING,
  FLOOR,
}
